import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';

import { UIService } from '../../services/ui.service';
import { APIService } from '../../services/api.service';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: 'cs-estabelecimentos',
    templateUrl: './estabelecimentos.component.html',
    styleUrls: ['./estabelecimentos.component.scss']
})
export class EstabelecimentosComponent implements OnInit {

    @Input() modal: string = undefined;

    public _columns: string[] = [];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    // *** todo: criar componente de filtro para estabelecimentos ser usado em outras telas
    public model: any = {
        Inativos: true,
        FiltroEstabelecimento: {
        }
    };

    public unidades: any[] = [];
    public listRedes: any[] = [];
    public listGrupos: any[] = [];

    public total: number;
    public dataSource = new MatTableDataSource<any>(this.unidades);
    public selection = new SelectionModel<any>(true, []);

    public unidadeSelecionada: any;

    constructor(public dialog: MatDialog, private ui: UIService, private api: APIService, private router: Router, private storage: StorageService) {
    }

    ngOnInit() {

        setTimeout(() => {

            this._columns = [this.modal !== undefined ? 'Selecionado' : 'Acoes', 'Rede', 'Grupo', 'Nome', 'CNPJ'];

            this.paginator.pageSize = 10;

            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

            if (this.modal) {

                this.model.Inativos = false;
            }

            this.loadSession();

            this.ui.block('Pesquisando redes...');
            this.api.listarRedes({}).subscribe(

                (response: any) => {

                    this.ui.unblock();

                    if (response.error) {

                        this.ui.error(response.error);
                    }
                    else {

                        //this.redes = response.data.Redes;
                        if (response.data.Redes.length > 1) {
                            this.listRedes = [{
                                "ID": "",
                                "Nome": "Todas"
                            }].concat(response.data.Redes);
                            this.model.FiltroEstabelecimento.RedeID = '';
                        } else {
                            this.listRedes = response.data.Redes;
                            this.model.FiltroEstabelecimento.RedeID = this.listRedes[0].ID;
                        }

                    }

                }
            );


        });
    }

    limparFiltro() {

        this.model = {
            Inativos: true,
            FiltroEstabelecimento: {
            }
        };
    }

    filtrar(page?: number, reset = false) {

        this.ui.block('Pesquisando estabelecimentos...');

        let skip: number = (page || this.paginator.pageIndex) * this.paginator.pageSize;
        if (reset) {
            skip = 0;
            this.paginator.pageIndex = 0;
        }
        const parameter: any = JSON.parse(JSON.stringify(this.model));

        parameter.Take = this.paginator.pageSize;
        parameter.Skip = skip;

        //if (this.sort && this.sort.direction) {
        //    parameter.Sort = this.sort.active + '|' + this.sort.direction;
        //}
        //else {
        //    parameter.Sort = 'Nome|asc';
        //}
        
        if (parameter.FiltroEstabelecimento && parameter.FiltroEstabelecimento.GrupoID=="") {
            parameter.FiltroEstabelecimento.GrupoID = '00000000-0000-0000-0000-000000000000';
        }
        if (parameter.FiltroEstabelecimento && parameter.FiltroEstabelecimento.RedeID=="") {
            parameter.FiltroEstabelecimento.RedeID = '00000000-0000-0000-0000-000000000000';
        }
        this.api.obterEstabelecimentos(parameter).subscribe(

            (response: any) => {

                this.ui.unblock();

                if (response.error) {

                    this.ui.error(response.error);
                }
                else {

                    this.total = response.data.Total;
                    this.unidades = response.data.Estabelecimentos;

                    this.dataSource = new MatTableDataSource<any>(response.data.Estabelecimentos);
                    this.selection = new SelectionModel<any>(true, []);

                    if (page) {

                        this.paginator.pageIndex = page;
                    }
                }

                this.storage.set('session', undefined);
            }
        );
    }

    isAllSelected() {

        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;

        return numSelected === numRows;
    }

    masterToggle() {

        this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => this.selection.select(row));
    }

    pageChanged(page: any) {

        this.filtrar();
    }

    sortChanged(sort: any) {

        this.filtrar();
    }

    newRecord() {

        this.saveSession();
        this.router.navigate(['/estabelecimentos', 0]);
    }

    editRecord(element: any) {

        this.saveSession();
        this.router.navigate(['/estabelecimentos', element.ID]);
    }

    deleteRecord(element: any) {
    }

    telefone(telefone: string) {

        if (telefone && telefone.length === 11) {

            return '(' + telefone.substr(0, 2) + ') ' + telefone.substr(2, 5) + '-' + telefone.substr(7, 4);
        }
        else {

            return telefone;
        }
    }

    saveSession() {

        this.storage.set('session', {
            model: this.model,
            page: {
                size: this.paginator.pageSize,
                current: this.paginator.pageIndex
            },
            sort: {
                field: this.sort.active,
                direction: this.sort.direction
            }
        });
    }

    loadSession() {

        const session = this.storage.get('session');

        if (session) {

            this.model = session.model;
            this.paginator.pageSize = session.page.size;
            this.sort.active = (session.sort) ? session.sort.field : 'Nome';
            this.sort.direction = (session.sort) ? session.sort.direction : 'asc';

            this.filtrar(session.page.current);
        }
        else {

            this.filtrar();
        }
    }

    selecionaUnidade(unidade: any) {

        this.unidadeSelecionada = unidade;
    }

    rowSelected(row: any) {

        if (!this.modal) {

            return;
        }

        if (this.modal === 'single') {

            this.selecionaUnidade(row);
        }
        else if (this.modal === 'multiple') {

            this.selection.toggle(row);
        }
    }

    redeSelected(e) {
        var grupos = [];
        if (!e.value) {
            this.model.FiltroEstabelecimento.GrupoID = '';
            this.listGrupos = grupos;
        } else {
            const rede = this.listRedes.filter((r) => {
                return r.ID == e.value;
            });
            if (!rede.length) {
                this.model.FiltroEstabelecimento.GrupoID = '';
                this.listGrupos = grupos;
            } else {
                grupos = rede[0].Grupos;
                if (grupos.length == 0) {
                    this.listGrupos = grupos;
                } else if (grupos.length == 1) {
                    this.model.FiltroEstabelecimento.GrupoID = grupos[0].ID;
                    this.listGrupos = grupos;
                } else {
                    this.model.FiltroEstabelecimento.GrupoID = '';
                    this.listGrupos = [{
                        "ID": "",
                        "Nome": "Todos"
                    }].concat(grupos);

                }
            }

        }

    }

}
